export const smallShadow =
  '0 1px 6px rgb(0, 0, 0, 0.08), 0 1px 2px rgb(0, 0, 0, 0.05)';
export const mediumShadow = '0 3px 12px rgb(0, 0, 0, 0.12)';
export const largeShadow = '0 4px 24px rgb(0, 0, 0, 0.16)';
